/**
 * Секрет TOTP генерируется на клиенте (RFC 4226/6238, 20 байт, base32 без «=»),
 * показывается как QR и подтверждается кодом — сервер хранит его только зашифрованным.
 */
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'

export function generateTotpSecret(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(20))
  let bits = 0
  let value = 0
  let out = ''
  for (const b of bytes) {
    value = (value << 8) | b
    bits += 8
    while (bits >= 5) {
      out += ALPHABET[(value >>> (bits - 5)) & 31]
      bits -= 5
    }
  }
  if (bits > 0) out += ALPHABET[(value << (5 - bits)) & 31]
  return out
}

/** Ссылка для приложений-аутентификаторов; параметры совпадают с бэкендом (SHA1, 6 цифр, 30 с). */
export function otpauthUrl(secret: string, username: string): string {
  const issuer = 'Кличат'
  const label = encodeURIComponent(`${issuer}:${username}`)
  return `otpauth://totp/${label}?secret=${secret}&issuer=${encodeURIComponent(issuer)}&algorithm=SHA1&digits=6&period=30`
}

/** Группы по четыре символа — так секрет удобнее вводить вручную. */
export function formatSecret(secret: string): string {
  return secret.replace(/(.{4})/g, '$1 ').trim()
}
